import React from 'react';
import { motion } from 'framer-motion';
const notions = ['Schémas pédagogiques', 'Tableaux synthétiques', 'Représentations moléculaires', 'Comparaisons visuelles', 'Étapes de résolution', 'Fiches à projeter'];
export function VisualApproachSection() {
  return <section className="w-full bg-white px-5 py-8 sm:py-12" data-id="element-261" data-mp="2l8m6kebeu09d">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-3xl" data-id="element-262" data-mp="2l71csqwx6lck">
        <div className="mx-auto max-w-2xl text-center" data-id="element-263" data-mp="1xbovmopllyn8">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-264" data-mp="1xd9o88scr7ig">
            Une chimie plus visuelle, sans refaire les schémas
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-ink/75 sm:mt-4 sm:text-base" data-id="element-265" data-mp="3rpprd0puq5j3">
            Une partie des notions de chimie repose sur des modèles que les élèves ne voient pas
            directement. Les supports sont conçus pour relier les niveaux macroscopique, microscopique
            et symbolique : vos élèves peuvent observer, comparer et exploiter les représentations,
            pendant que vous gardez la main sur l’explication.
          </p>
        </div>

        <ul className="mt-6 grid grid-cols-2 gap-2.5 sm:mt-8 sm:grid-cols-3 sm:gap-3" data-id="element-266" data-mp="30etsqzdxc4d1">
          {notions.map(notion => <li key={notion} className="rounded-xl border border-cobalt/20 bg-cobalt/5 px-3 py-3 text-center text-[13px] font-semibold text-cobalt-deep sm:px-4 sm:text-sm" data-id="element-267" data-mp="2cq0s4pmcx8c3">
              {notion}
            </li>)}
        </ul>

      </motion.div>
    </section>;
}